import React, { useEffect, useState } from 'react';
import { Container, Grid, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboardData } from 'src/store/actions/DashboardActions';
import SuperUserDashboard from './SuperUserDashboard';
import SubUserDashboard from './SubUserDashboard';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Dashboard = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const profile = useSelector((state) => state.Auth.profile);

  useEffect(() => {
    dispatch(getDashboardData());
  }, []);

  if (profile?.super == '1') {
    return <SuperUserDashboard />;
  }
  return <SubUserDashboard />;
};

export default Dashboard;
